export enum NormalizedOutcomeName {
  APPROVED = 'approved',
  DENIED = 'denied',
  MANUAL_REVIEW = 'manual review',
}
